import { useContext } from "react";

const OurParner = () => {
  return (
    <div className="gallery-carousel">
    <div className="container-fluid">
        <div className="container">
            <div className="section-title">
                <h3 className="wow fadeInUp">Parner</h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque">
                    <span>Our Parner</span>
                </h2>
            </div>
        </div>
        <div className="row">
            <div className="col-lg-12">
                {/* Scrolling Content Start */}
                <div className="gallery-carousel-box">
                    <div className="gallery-scrolling-content">
                        {/* Image Item Start */}
                        <div className="gallery-image">
                            <figure className="image-anime">
                                <img src="images/crypto/parners/bsc.png" width={315} alt="" />
                            </figure>
                        </div>
                        {/* Image Item End */}
                        {/* Image Item Start */}
                        <div className="gallery-image">
                            <figure className="image-anime">
                                <img
                                    src="images/crypto/parners/pancake.jpg"
                                    width={315}
                                    alt=""
                                />
                            </figure>
                        </div>
                        {/* Image Item End */}
                        <div className="gallery-image">
                            <figure className="image-anime">
                                <img
                                    src="images/crypto/parners/tradingview.png"
                                    width={315}
                                    alt=""
                                />
                            </figure>
                        </div>
                        <div className="gallery-image">
                            <figure className="image-anime">
                                <img
                                    src="images/crypto/parners/coingecko.png"
                                    width={315}
                                    alt=""
                                />
                            </figure>
                        </div>
                        <div className="gallery-image">
                            <figure className="image-anime">
                                <img
                                    src="images/crypto/parners/arkm.png"
                                    width={315}
                                    alt=""
                                />
                            </figure>
                        </div>
                        <div className="gallery-image">
                            <figure className="image-anime">
                                <img
                                    src="images/crypto/parners/eigen.png"
                                    width={315}
                                    alt=""
                                />
                            </figure>
                        </div>
                    </div>
                    <div className="gallery-scrolling-content">
                        <div className="gallery-image">
                            <figure className="image-anime">
                                <img src="images/crypto/parners/bsc.png" width={315} alt="" />
                            </figure>
                        </div>
                        <div className="gallery-image">
                            <figure className="image-anime">
                                <img
                                    src="images/crypto/parners/pancake.jpg"
                                    width={315}
                                    alt=""
                                />
                            </figure>
                        </div>
                        <div className="gallery-image">
                            <figure className="image-anime">
                                <img
                                    src="images/crypto/parners/tradingview.png"
                                    width={315}
                                    alt=""
                                />
                            </figure>
                        </div>
                        <div className="gallery-image">
                            <figure className="image-anime">
                                <img
                                    src="images/crypto/parners/coingecko.png"
                                    width={315}
                                    alt=""
                                />
                            </figure>
                        </div>
                        <div className="gallery-image">
                            <figure className="image-anime">
                                <img
                                    src="images/crypto/parners/arkm.png"
                                    width={315}
                                    alt=""
                                />
                            </figure>
                        </div>
                        <div className="gallery-image">
                            <figure className="image-anime">
                                <img
                                    src="images/crypto/parners/eigen.png"
                                    width={315}
                                    alt=""
                                />
                            </figure>
                        </div>
                        {/* Image Item End */}
                    </div>
                </div>
                {/* Scrolling Content End */}
            </div>
        </div>
    </div>
</div>
  )
}

export default OurParner;